import React, { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Row, Col, Label } from 'reactstrap'
import { Main, MainTop, MainTopTitle, MainBody, WhiteBox } from '@/components/Layout'
import context from '@/context'
import { actionCreators } from '@/store/ReportTemplate'
import Resx from '@/components/Resx'
import ErrorBoundary from '@/components/ErrorBoundary'
import LoadingIndicator from '@/components/LoadingIndicator'
import Name from '@/components/Name'
import { reportType as reportTypeEnum } from '@/enums/reportType'
import getEnumTranslation from '@/enums/enums'
import { BsrsGrid, Column, commandColumnProps } from '@/components/BsrsGrid'
import { useLocalization } from '@/hooks/localization'
import { useDispatch } from '@/hooks/dispatch'
import { DownloadVersionDefinitions } from './downloadVersionDefinitions'

const ReportTemplateDetail = React.memo((props) => {
  const id = props.match.params.id

  const [getReportTemplate] = useDispatch([actionCreators.getReportTemplate])

  useEffect(() => getReportTemplate(id), [getReportTemplate, id])

  const {
    reportType,
    code,
    reportTemplateVersionName,
    reportTemplateVersionLatinName,
    reportTemplateCategory,
    latestVersionId,
    loading
  } = useSelector(state => {
    if (state.reportTemplate.reportTemplate) {
      return {
        reportType: state.reportTemplate.reportTemplate.reportType,
        code: state.reportTemplate.reportTemplate.code,
        reportTemplateVersionName: state.reportTemplate.reportTemplate.reportTemplateVersionName,
        reportTemplateVersionLatinName: state.reportTemplate.reportTemplate.reportTemplateVersionLatinName,
        reportTemplateCategory: state.reportTemplate.reportTemplate.reportTemplateCategory,
        latestVersionId: state.reportTemplate.reportTemplate.latestVersionId,
        loading: false
      }
    } else {
      return { loading: true }
    }
  })

  const { localize } = useLocalization()

  const enumName = reportTypeEnum.enumName
  const dataSource = useCallback(req => context.api.reportTemplateService.getTableData(id, req), [id])

  return loading ? <LoadingIndicator /> : <Main>
    <MainTop>
      <MainTopTitle backUrl='/administration-report-templates'>
        <Resx name='Reporting.ReportTemplate' />
      </MainTopTitle>
    </MainTop>
    <MainBody transparent>
      <WhiteBox header='Reporting.ReportTemplate' buttons={<DownloadVersionDefinitions templateVersionId={latestVersionId} />} dataCy={'ReportTemplateList'}>
        <ErrorBoundary>
          <React.Fragment>
            <div>
              <Row>
                <Col lg='6'>
                  <Label><Resx name='Reporting.ReportType' />: </Label>
                  <span className='ml-2'>{getEnumTranslation({ localize, enumName, value: reportType })}</span>
                </Col>
              </Row>
              <Row>
                <Col lg='6'>
                  <Label><Resx name='Common.Code' />: </Label>
                  <span className='ml-2'>{code}</span>
                </Col>
              </Row>
              <Row>
                <Col lg='6'>
                  <Label><Resx name='Common.Name' />: </Label>
                  <span className='ml-2'>{reportTemplateVersionName}</span>
                </Col>
              </Row>
              <Row>
                <Col lg='6'>
                  <Label><Resx name='Common.LatinName' />: </Label>
                  <span className='ml-2'>{reportTemplateVersionLatinName}</span>
                </Col>
              </Row>
              <Row>
                <Col lg='6'>
                  <Label><Resx name='Reporting.ReportTemplateCategoryName' />: </Label>
                  <span className='ml-2'><Name data={reportTemplateCategory} /></span>
                </Col>
                <Col lg='6'>
                  <Label><Resx name='LatestVersionId' />: </Label>
                  <span className='ml-2'>{latestVersionId}</span>
                </Col>
              </Row>
              <Row><Col>&nbsp;</Col></Row>
            </div>
            <WhiteBox header='Reporting.Versions'>
              <BsrsGrid persistenceId={'report-templates'} dataSource={dataSource}>
                <Column field='order' title={localize('Common.Order')} editable={false} filter='numeric' />
                <Column field='version' title={localize('Common.Version')} editable={false} filter='numeric' />
                <Column field='name' title={localize('Common.Name')} editable={false} />
                <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
                <Column {...commandColumnProps({ detailUrl: x => `/administration-report-templates/${id}/version/${x.id}` })} />
              </BsrsGrid>
            </WhiteBox>
          </React.Fragment>
        </ErrorBoundary>
      </WhiteBox>
    </MainBody>
  </Main>
})

export default ReportTemplateDetail



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/report-templates/detail.js